import { Card, AspectRatio, Img, Flex, Typography } from "@xcorejs/ui";
import Popover from "design-system/robe/Popover";
import { Paragraph } from "design-system";
import { PropsWithChildren } from "react";
import { resolveSrcSet } from "utils";
import { useLayout } from "xcore";
import { Innovation, InnovationValues } from "xcore/types";

interface InnovationCardProps {
  innovation: Innovation<keyof Pick<InnovationValues, "image">>;
  expandUp: boolean;
  intro: string;
  name: string;
}

export const InnovationCard = ({ innovation: { values }, expandUp, children, intro, name }: PropsWithChildren<InnovationCardProps>) => {
  const { image } = useLayout();
  const imgUrl = values.image ? image(values.image, { width: 410, height: 230 }) : null;
  const retinaImgUrl = values.image ? image(values.image, { width: 410, height: 230, enlargement: 2 }) : null;

  return (
    <Popover
      popover={
        <Card
          v="outline"
          width="41rem"
          maxWidth="100%"
          media={
            values.image &&
            imgUrl && (
              <AspectRatio ratio={9 / 16}>
                <Img src={imgUrl} {...resolveSrcSet(imgUrl, retinaImgUrl)} alt={name} loading="lazy" width="100%" />
              </AspectRatio>
            )
          }
          _media={{
            maxWidth: "100%",
          }}
          body={
            <Flex width="100%" flexDirection="column" alignItems="center">
              <Typography v="h4">{name}</Typography>
              <Paragraph textAlign="center" mt="1rem">
                {intro}
              </Paragraph>
            </Flex>
          }
          _body={{
            p: "3rem",
            pt: "2rem",
          }}
          cursor="pointer"
        />
      }
      _popover={{
        marginLeft: "2.5rem",
        pt: "0.6rem",
        transform: {
          _: expandUp ? "translateX(50% -106%)" : "translateX(50%)",
          md: expandUp ? "translateX(-100%) translateY(-106%)" : "translateX(-100%)",
        },
        display: { _: "none", md: "block" },
      }}
    >
      {children}
    </Popover>
  );
};
